<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="devId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="设备型号" v-model="termVersion"></el-input>
      </el-col>
      <el-col :span="14">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <!-- <el-col :span="2">
        <router-link to="./add">
          <el-button type="success">新增</el-button>
        </router-link>
      </el-col> -->
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="devId" label="设备编号"> </el-table-column>
      <el-table-column prop="termVersion" label="设备型号"> </el-table-column>
      <el-table-column prop="inJoin" label="关联场景">
        <template slot-scope="scope">
          {{
            scope.row.inJoin == 0
              ? "-"
              : scope.row.inJoin == 1
              ? "仓库"
              : scope.row.inJoin == 2
              ? "门店"
              : scope.row.inJoin == 3
              ? "运输"
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column prop="termName" label="型号名称"> </el-table-column>
      <el-table-column prop="outBillNo" label="出库编号"> </el-table-column>
      <el-table-column prop="lastInsitution" label="上次机构"> </el-table-column>
      <el-table-column prop="institution" label="机构/个人"> </el-table-column>
      <el-table-column prop="useStatus" label="使用状态"> </el-table-column>
      <el-table-column prop="outStockDate" label="出库时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            v-show="scope.userType != 1"
            type="text"
            size="small"
            @click="Edit(scope.$index)"
            >编辑</el-button
          >
          <el-button
            v-show="scope.userType != 1"
            type="text"
            size="small"
            @click="onRecord(scope.row)"
            >修改记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
    <el-dialog title="修改记录" :visible.sync="open" @close="closeDailog">
      <el-row class="search-add" :gutter="10">
        <el-col :span="24"> 设备编号：{{editData.devId}} </el-col>
      </el-row>
      <el-table :data="recordData" border stripe style="width: 100%">
        <el-table-column prop="outBillNo"  label="出库批次编号">
        </el-table-column>
        <el-table-column prop="create_time" label="修改时间">
        </el-table-column>
        <el-table-column prop="beforeContent" label="修改前机构名称"> </el-table-column>
        <el-table-column prop="afterContent" label="修改后机构名称"> </el-table-column>
      </el-table>
      <div class="tableDel-Page">
        <el-pagination
          :current-page="recordPagin.pageNum"
          :page-size="recordPagin.pageSize"
          layout="prev, pager, next"
          :total="recordPagin.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDailog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      termVersion: "",
      devId: "",
      data: [],
      open: false,
      editData: {},
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      recordPagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    onRecord(data) {
      console.log(data);
      this.open = true;
      this.editData = data;
      this.recordList()
    },
    recordList() {
      const params = {
        pageNum: this.recordPagin.pageNum,
        pageSize: this.recordPagin.pageSize,
        devId: this.editData.devId,
      };
      this.$http
        .post("/manage/outBillLog/pageListByDevId", params)
        .then((res) => {
          this.recordData = res["data"]["data"]["records"];
          this.recordPagin.total = res["data"]["data"]["total"];
        });
    },
    closeDailog() {
      this.open = false;
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.termVersion.trim() != "") {
        params.termVersion = this.termVersion;
      }
      if (this.devId.trim() != "") {
        params.devId = this.devId;
      }
      this.$http.post("/manage/outStock/list", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    Edit(index) {
      this.$store.commit("setEditInfo", this.data[index]);
      this.$router.push("./editins/" + this.data[index].devId);
    },
  },
  components: { Pagination },
};
</script>